import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    width: '100%',
    height: 'calc(100% - 25px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  progress: {
    stroke: '#2E2E38',
  },
});

class Spinner extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    size: PropTypes.number,
  };

  render() {
    const { classes, size } = this.props;
    return (
      <section className={classNames(classes.root, 'spinner')}>
        <svg className={classes.progress} width={size} height={size} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <g transform="translate(1 1)" strokeWidth="2">
              <circle strokeOpacity=".15" cx="18" cy="18" r="18" />
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
              </path>
            </g>
          </g>
        </svg>
      </section>
    );
  }
}

export default styled(Spinner)(styles);
